module.exports = __webpack_public_path__ + "static/media/chat.30b8e1f6.svg";